import { modal } from '../modal-template/modal-template';

function handleReferral() {
    console.log('handleReferral');

    const referral = window.__APP_REFERRAL || null;
    if (!referral) return;


    // чистим глобалку
    try {
        delete window.__APP_REFERRAL;
    } catch (e) {
        window.__APP_REFERRAL = null;
    }

    const openRegisterModal = () => {
        modal.open('register', { referal: referral });
    };

    if (modal && typeof modal.open === 'function') {
        openRegisterModal();
    } else {
        document.addEventListener('modal-ready', function handler() {
            document.removeEventListener('modal-ready', handler);
            openRegisterModal();
        });
    }
}

document.addEventListener('DOMContentLoaded', function handler() {
    document.removeEventListener('DOMContentLoaded', handler);
    handleReferral();
});
